import { render, staticRenderFns } from "./Referans.vue?vue&type=template&id=fe923856&scoped=true&"
import script from "./Referans.vue?vue&type=script&lang=js&"
export * from "./Referans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe923856",
  null
  
)

export default component.exports